export const calcValueLength = value => {
  var _ref;
  return Array.isArray(value) ? value.reduce((accumulator, value) => accumulator + value.length, 0) : (_ref = "".concat(value || '')) === null || _ref === void 0 ? void 0 : _ref.length;
};